import { useState,useEffect } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import {updateProfileAsync, sendVerifyEmailAsync,setVerifyEmail, setErrorProfile} from '../../services/profile/profileSlice'
import { useDispatch,useSelector } from 'react-redux';
import ResultSend from '../../components/alert/ResultSend';
import Stack from '@mui/material/Stack';
import {  getDownloadURL, ref as storageRef,  uploadBytes } from 'firebase/storage';
import {storage} from '../../config/firebase-config';
import Translation from '../../utils/Translation';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { checkFindProfileUser, allDomain } from '../../utils/helpers';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

export default function Profile() {
  const auth = useSelector(state => state.auth);
  const dynamicState = useSelector(state => state.dynamicConfig);
  const {userProfile,errorProfile,statusUpdateProfile,statusProfileUpdateFirstTime,statusVerifyEmail,verifyEmail} = useSelector(state => state.profile);
  const user = auth.user;
  const [nickName,setNickname] = useState(userProfile?.nickname || user?.displayName || '');
  const [email,setEmail] = useState(userProfile?.email || user?.email || '');
  const [mobileNumber, setMobileNumber] = useState(
    userProfile?.mobile_number || user?.phoneNumber || ''
  );
  const [msg,setMsg]= useState(null);
  const [update,setUpdate]= useState(false);
  const dispatch = useDispatch();
  const handleMsg=(value)=> setMsg(value);
  const [image, setImage]  = useState(null);
  const [previewImage, setPreviewImage]  = useState(null);
  const [userFormType,setUserFormType] = useState(0);
  const [password,setPassword] = useState('');
  const [confirmPassword,setConfirmPassword] = useState('');
  const [showPassword,setShowPassword] = useState(false);
  const [showConfirmPassword,setShowConfirmPassword] = useState(false);
  const sellHost    = new URL(allDomain.seller).host;
  const isSellDomain = window.location.host === sellHost;
  const isSocialAuthUser = userProfile?.auth_provider === 'google' || userProfile?.auth_provider === 'apple';
  const hasPhone = !!(user?.phoneNumber || userProfile?.mobile_number);
  const isNewProfile = !checkFindProfileUser(userProfile);

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  // mirrors the password rules enforced on first-time profile creation in the mobile app
  const validatePassword = (value) => {
    if (!value) return <Translation data="profile.password_required" />;
    if (value.length <= 6) return <Translation data="profile.password_too_short" />;
    if (!/[A-Z]/.test(value) || !/[a-z]/.test(value) || !/[0-9]/.test(value) || !/[!@#$%^&*(),.?":{}|<>]/.test(value))
      return <Translation data="profile.password_weak" />;
    return null;
  };

  const handleUploadChange = (e) => {
    if (e.target.files[0]) {
      setImage(e.target.files[0]);
      setPreviewImage(URL.createObjectURL(e.target.files[0]))
    }
  };

  const handleButton =  () =>{

    if(!(email && nickName && (userFormType === 0 || userFormType === 2)))
      return true;

    if(isNewProfile && (validatePassword(password) || password !== confirmPassword))
      return true;

    return false;
  }

  const handleUpload = () => {
    
    const imageRef = storageRef(storage, `user/${auth.user.uid}`);

     uploadBytes(imageRef, image)
      .then((snapshot) => {
        getDownloadURL(snapshot.ref)
          .then((imgUrl) => {
            sendProfile(imgUrl);
          })
          .catch((error) => {
            console.log(error)
          });
      })
      .catch((error) => {
        console.log(error)
      });
  
  };

  const handleSendProfile = (e) => {
    e.preventDefault();

    if(!validateEmail(email)){
      dispatch(setErrorProfile("email not valid"));
      handleMsg("email not valid");
      return;
    }

    if(isNewProfile){
      const passwordError = validatePassword(password);
      if(passwordError){
        dispatch(setErrorProfile("password invalid"));
        handleMsg(passwordError);
        return;
      }
      if(password !== confirmPassword){
        dispatch(setErrorProfile("password mismatch"));
        handleMsg(<Translation data="profile.password_mismatch" />);
        return;
      }
    }

    dispatch(setErrorProfile(null));
    if(image)
      handleUpload(); // upload image
    else
      sendProfile(userProfile?.profile_image_url);
  }

  const sendProfile = (profile_url) => {
    const passwordToSend = isNewProfile ? password : undefined;

    if (isSellDomain && !checkFindProfileUser(userProfile) ){
      dispatch(updateProfileAsync({auth,dynamicState,nickName,email,profile_url,userFormType:'2',mobileNumber,password:passwordToSend}));
    }else{
      dispatch(updateProfileAsync({auth,dynamicState,nickName,email,profile_url,userFormType,mobileNumber,password:passwordToSend}));
    }
    handleMsg("");
    setUpdate(true);
  }

  const handleSendVerifyEmail = () =>{
    
    if(verifyEmail)
      return;

    dispatch(sendVerifyEmailAsync({auth,dynamicState}));
  }

  useEffect(()=>{

    if(statusVerifyEmail === "succeeded") {
      // for prevent resend verify email
      dispatch(setVerifyEmail(true));
    }
     
    if(statusVerifyEmail === "failed")
      handleMsg(errorProfile)

  },[statusVerifyEmail,dispatch]);


  useEffect(()=>{
  
    if(statusUpdateProfile === "succeeded" || statusProfileUpdateFirstTime === "succeeded") {
      (update) && handleMsg(<Translation data="profile.msg"  />);
      dispatch(setVerifyEmail(userProfile?.email_verified === 0? false :true));
      setPreviewImage(null);
    }

    if(statusUpdateProfile === "failed" || statusProfileUpdateFirstTime === "failed")  (update) && handleMsg(errorProfile);
    
  },[statusUpdateProfile,statusProfileUpdateFirstTime,dispatch]);

  // Update fields when profile loads (handles case where profile was null on mount)
  useEffect(() => {
    if (userProfile?.email && !email) {
      setEmail(userProfile.email);
    }
    if (userProfile?.nickname && !nickName) {
      setNickname(userProfile.nickname);
    }
    if (userProfile?.mobile_number && !mobileNumber) {
      setMobileNumber(userProfile.mobile_number);
    }
  }, [userProfile]);

  return (
    <Box sx={{
        marginTop: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        p: 5
      }}>

    <Box sx={{margin:"10px"}}>
        <Avatar className='profile-avatar'  src={(userProfile?.profile_image_url)?
        userProfile.profile_image_url:require('../../assets/image/profile/avatar.jpg')} />
    </Box>
  
    <Typography component="h1" variant="b" sx={{fontSize:"30px"}}>
      {(userProfile?.nickname)?userProfile.nickname:<Translation data = "profile.user_profile"  /> }
    </Typography>

    <Box component="form"  noValidate sx={{ mt: 1,width:"50%" }} className='input-profile' onSubmit={(e) =>handleSendProfile(e)} >

      <TextField
        id="outlined-mobile-number"
        label={<Translation data="profile.mobile_number" />}
        value={mobileNumber}
        onChange={hasPhone ? undefined : (e) => setMobileNumber(e.target.value)}
        placeholder={hasPhone ? '' : '+971XXXXXXXXX'}
        helperText={!hasPhone ? 'Enter your mobile number with country code (e.g. +971...)' : undefined}
        InputProps={{
          readOnly: hasPhone,
        }}
        fullWidth
      />

      <TextField
        id="outlined-required"
        label=<Translation  data="profile.nickName"  />
        type='text'
        value={nickName}
        onChange={(e) => setNickname(e.target.value)}
        fullWidth
        />

        <TextField
            required
            id="outlined-required"
            label=<Translation  data="profile.email"  />
            type='email'
            onChange={isSocialAuthUser && email ? undefined : (e) => setEmail(e.target.value)}
            value={email}
            fullWidth
            InputProps={{
              readOnly: isSocialAuthUser && !!email,
            }}
            helperText={isSocialAuthUser && email ? `Email from your ${userProfile?.auth_provider === 'apple' ? 'Apple' : 'Google'} account` : undefined}
          />  

          {!isSocialAuthUser && (userProfile?.email === email) && (userProfile?.email_verified === 0) &&
          <Stack direction="row" spacing={2} sx={{mb:'1rem'}}>
          {
            verifyEmail ? 
             <Button variant="outlined" className='button-verify'  disabled>
               <Translation  data="profile.verify_email"  /> </Button> 
             :
             <Button variant="outlined" className='button-verify'  onClick={()=>handleSendVerifyEmail()}>
             <Translation  data="profile.verify_email"  /> </Button>
          }
          </Stack>
          }

          {isNewProfile &&
            <>
              <TextField
                required
                id="outlined-password"
                label={<Translation data="profile.password" />}
                helperText={<Translation data="profile.password_hint" />}
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <TextField
                required
                id="outlined-confirm-password"
                label={<Translation data="profile.confirm_password" />}
                type={showConfirmPassword ? 'text' : 'password'}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                fullWidth
                error={!!confirmPassword && confirmPassword !== password}
                helperText={!!confirmPassword && confirmPassword !== password ? <Translation data="profile.password_mismatch" /> : undefined}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)} edge="end">
                        {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </>
          }

      <Box sx={{display:"block"}}>
        {previewImage &&
          <Box  className="img-store">
            <img src={previewImage} alt="Preview" />
          </Box>
        }
        <TextField sx={{width:"100%"}} id="outlined-basic"  variant="outlined" type='file' onChange={handleUploadChange}  />
      </Box>


     {!isSellDomain && !checkFindProfileUser(userProfile) && 
      <Box sx={{display:"block"}}>
          <FormControl>
              <FormLabel id="demo-row-radio-buttons-group-label font-weight">
                 <Translation data = "profile.user_type"  /> 
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue="0">
                  <FormControlLabel value="0" control={<Radio />} label="Customer" onChange={() => setUserFormType(0)} />
                  <FormControlLabel value="2" control={<Radio />} label="Seller" onChange={() => setUserFormType(2)} />
              </RadioGroup>
          </FormControl>
       </Box>
      }
      
      {(msg) &&  <ResultSend className="mt-1" msg={msg}  error={errorProfile?true:false} />}

      <Button
        type="submit"
        fullWidth
        variant="contained"
        disabled={handleButton()}
        sx={{ mt: 3, mb: 2 }}>
        <Translation  data="profile.update"  /> 
      </Button>

    </Box>

  </Box>
  );
}







